/**
 * Converts a ResourceTiming sample to bandwidth in bits per second (bps).
 *
 * @param sample - A ResourceTiming sample
 * @returns
 */
export function getBandwidthBps(sample) {
    const durationSeconds = sample.duration / 1000;
    const bandwidthBps = sample.encodedBodySize * 8 / durationSeconds;
    return bandwidthBps;
}
//# sourceMappingURL=getBandwidthBps.js.map